module.exports = __webpack_public_path__ + "c50977c9313399ec833b93d86a89be70.svg";